var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.293945,
    width: 56.9124,
    height: 56.9124,
    rx: 28.4562,
    fill: "#E60012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1601 13C22.8267 13 23.4409 13.3615 23.7644 13.9443L26.009 17.9874C26.3028 18.5168 26.3166 19.1571 26.0458 19.6986L23.8836 24.0232C23.8836 24.0232 24.5102 27.2449 27.1327 29.8673C29.7551 32.4898 32.966 33.1056 32.966 33.1056L37.2899 30.9437C37.8318 30.6727 38.4726 30.6867 39.0021 30.9811L43.0567 33.2353C43.6389 33.559 44 34.1729 44 34.8391V39.4938C44 41.8642 41.7982 43.5763 39.5522 42.8184C34.9392 41.2619 27.7787 38.2983 23.2402 33.7598C18.7017 29.2213 15.7381 22.0607 14.1816 17.4478C13.4237 15.2018 15.1358 13 17.5062 13H22.1601Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c3e9c1da38d9418e27124f9098ba31dc.svg";
export { ForwardRef as ReactComponent };